module.exports = __webpack_public_path__ + "img/logo-mini.9c5658b1.svg";